import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DiCssdeck } from 'react-icons/di';

function Desktop() {
	return (
		<nav className="w-11/12 h-fit m-auto flex flex-row justify-between items-center">
			<div className="w-fit h-fit flex justify-between items-center text-blue text-3xl font-semibold cursor-text">
				<Link
					to={'/'}
					className="w-fit h-fit flex flex-row justify-between items-center"
				>
					<DiCssdeck />
					<span className="italic">Judith</span>
				</Link>
			</div>

			<ul className="w-fit h-fit flex flex-row justify-between items-center gap-9">
				{[
					['About', '/#about'],
					['Projects', '/projects'],
					['Technologies', '/#techs'],
					['Resume', '/#resume'],
				].map(([list, url], index) => (
					<motion.li
						whileHover={{ scale: 1.3 }}
						transition={{ type: 'tween', ease: 'easeInOut', duration: 0.9 }}
						key={index}
						className="text-lg font-normal"
					>
						<HashLink
							scroll={(element) =>
								element.scrollIntoView({ behavior: 'smooth' })
							}
							to={url}
							className="text-light-gray hover:text-blue relative hover:after:w-[25px] hover:after:h-[5px] hover:after:bg-[url('./images/dotted.svg')] hover:after:absolute hover:after:bg-no-repeat hover:after:inset-x-0 hover:after:bottom-[-5px] hover:after:mx-auto"
						>
							{list}
						</HashLink>
					</motion.li>
				))}
			</ul>
		</nav>
	);
}

export default Desktop;
